import { combineReducers } from 'redux';
import { SettingsReducer, initialSettingsState } from './settings';
import { VideoReducer } from './video';
import { ContentReducer } from './content';
import { SessionReducer, initialSessionState } from './session';
import { InvitationsReducer, initialInvitationsState } from './invitations';
import { ChatReducer } from './chat';
import { MediaReducer, initialMediaState } from './media';
import { ModalReducer } from './modal';
import { MeetingReducer, initialMeetingState } from './meeting';
import { NotificationsReducer } from './notifications';
import { NotesReducer } from './notes';
import { OpenTokReducer } from './opentok';
import { BroadcastReducer, initialBroadcastingState } from './broadcasting';
import { HomeReducer, HOME_ROUTES } from './home';
import { ShotsReducer, initialShotsState } from './shots';
import { GraphicsReducer, initialGraphicsState } from './graphics';
import { UserInterfaceReducer } from './user-interface';
import { TeleprompterReducer } from './teleprompters';
import { SHOW_DETAILS_BACK } from '../actions/main';
import { DebugReducer, initialDebugState } from './debug';
import { CommToggleReducer } from './comm-toggle';
import { GeneratedContentReducer, initialGeneratedContentState } from './generate-content';

function lastAction(state: any = null, action: any = null) {
	return action;
}

const appReducers = combineReducers({
	SettingsReducer,
	VideoReducer,
	ContentReducer,
	SessionReducer,
	InvitationsReducer,
	ChatReducer,
	NotificationsReducer,
	NotesReducer,
	MediaReducer,
	MeetingReducer,
	ModalReducer,
	OpenTokReducer,
	BroadcastReducer,
	lastAction,
	HomeReducer,
	ShotsReducer,
	UserInterfaceReducer,
	TeleprompterReducer,
	GraphicsReducer,
	DebugReducer,
	CommToggleReducer,
	GeneratedContentReducer,
});

export const baseStateForHomeView = (state: any) => ({
	...state,
	SettingsReducer: {
		...initialSettingsState,
		featureFlags: state.SettingsReducer.featureFlags,
	},
	InvitationsReducer: initialInvitationsState,
	MediaReducer: initialMediaState,
	MeetingReducer: initialMeetingState,
	BroadcastReducer: initialBroadcastingState,
	ShotsReducer: initialShotsState,
	HomeReducer: {
		...state.HomeReducer,
		currentRoute: HOME_ROUTES.SHOWS,
	},
	SessionReducer: {
		...state.SessionReducer,
		showSessionTypes: initialSessionState.showSessionTypes,
		showSessions: initialSessionState.showSessions,
		showSessionsLoading: initialSessionState.showSessionsLoading,
	},
	GraphicsReducer: initialGraphicsState,
	DebugReducer: initialDebugState,
	GeneratedContentReducer: initialGeneratedContentState,
});

const rootReducer = (state: any, action: any) => {
	// When a user returns to the home view from show details, we want to clear meeting-specific data.
	// This action is used to reset multiple reducers back to their initial state.
	if (action.type === SHOW_DETAILS_BACK) {
		return appReducers(baseStateForHomeView(state), action);
	}

	// when we use mainStore into our tests (which uses this rootReducer) -
	// we have to reset the reducers between tests
	if (action.type === 'RESET_REDUCERS_TO_INIT') {
		return appReducers(undefined, action);
	}

	return appReducers(state, action);
};

export default rootReducer;
